import { useMemo } from 'react'
import { useLocalStorage } from '@arcivr/sp-ui-lib'
import { FiltersState } from 'pages/TotalsByEventPage'
import { getQuickRange } from 'lib/timeRanges'

export const FILTERS_STORAGE_KEY = 'analytics_filters'

export const usePersistentAnalyticsFilters = (defaultFilters: FiltersState): readonly [FiltersState, (value: FiltersState) => void] => {
  const [storedFilters, setStoredFilters] = useLocalStorage<FiltersState>(FILTERS_STORAGE_KEY, defaultFilters)

  const { preset } = storedFilters.range
  const storedStart = new Date(storedFilters.range.startDate).getTime()
  const storedEnd = new Date(storedFilters.range.endDate).getTime()

  const range = useMemo(() => preset != null
    ? { ...getQuickRange(preset), preset }
    : { startDate: new Date(storedStart), endDate: new Date(storedEnd) }
  , [preset, storedStart, storedEnd])

  const hydratedFilters = useMemo(() => ({ ...storedFilters, range }), [storedFilters, range])

  return [hydratedFilters, setStoredFilters] as const
}
